(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerExcursionFilter',
	};

    $(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);

		$(document).on('click', '#search_excursion_btn', function _searchExcursion(e) {
			var $search      = $('.search_excursion').val();
			var itinerary_id = $('#itinerary-id').val();

			e.preventDefault();
			
			$('.lp-excursions').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading excursions...');

			Adzuki.Ajax.get('/LivePlanner/shoreExcursions/' + itinerary_id + '/' + $search)
			.then(function _selectSailing(content) {
				$('.lp-excursions').html(content);
			});
		});

		$(document).on('click', '#clear_excursion_btn', function _clearExcursion(e) {
			var itinerary_id = $('#itinerary-id').val();

			$('.search_excursion').val('');

			e.preventDefault();
			
			$('.lp-excursions').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading excursions...');

			Adzuki.Ajax.get('/LivePlanner/shoreExcursions/' + itinerary_id + '/')
			.then(function _selectSailing(content) {
				$('.lp-excursions').html(content);
			});
		});
	});
}(jQuery, window.Adzuki || {}));